module.exports = {
      id: "icon-document-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-document",
      toString: function () {
        return this.url;
      }
    }